import useSoftpullModalEvents from '~/hooks/flp/useSoftpullModalEvents';
import AllCreditTypes from './AllCreditTypes';
import Hero from './Hero';
import MarketingFAQ from './MarketingFAQ';
import SocialProofSection from './SocialProof';
import UnlockRealPayments from './UnlockRealPayments/UnlockRealPayments';
import PageViewAnalytics from '../PageViewAnalytics';

type OwnProps = {
  isLoggedIn?: boolean;
};

export default function MarketingContent({ isLoggedIn }: OwnProps) {
  useSoftpullModalEvents(true);

  return (
    <>
      <PageViewAnalytics page="marketing" />
      <Hero isLoggedIn={isLoggedIn} />
      <AllCreditTypes />
      <UnlockRealPayments />
      <SocialProofSection />
      <MarketingFAQ />
    </>
  );
}
